module.exports = __webpack_public_path__ + "img/icon_2.273d7c3.png";